import { render, staticRenderFns } from "./ReportConfig.vue?vue&type=template&id=39d3512a&"
import script from "./ReportConfig.vue?vue&type=script&lang=js&"
export * from "./ReportConfig.vue?vue&type=script&lang=js&"
import style0 from "./ReportConfig.vue?vue&type=style&index=0&id=39d3512a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports